import { Navigate } from "react-router-dom";
import { getStoredUser, hasClientSession } from "../api/session";

export default function RequireAuth({ children }) {
  const user = getStoredUser();

  if (!hasClientSession() || !user?.role) {
    return <Navigate to="/" replace />;
  }

  if (
    user?.role === "admin" &&
    user?.admin_mfa_required &&
    user?.admin_mfa_setup_required
  ) {
    return <Navigate to="/admin/mfa-setup" replace />;
  }

  if (
    user?.role === "admin" &&
    user?.admin_mfa_enabled &&
    user?.admin_mfa_required &&
    !user?.admin_mfa_verified
  ) {
    return <Navigate to="/admin/mfa-challenge" replace />;
  }

  return children;
}
